// extracted by mini-css-extract-plugin
module.exports = {"background":"ConfirmModal_background__3VvHX","modal":"ConfirmModal_modal__3Mini","question":"ConfirmModal_question__12_28","actions":"ConfirmModal_actions__1lRe8"};